import React from 'react';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import {useState} from "react";
import { useParams } from "react-router-dom";
import { Nav } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { addItem, increase, decrease } from './store.js';

import data from './review.js';

function Detail (props) {
    
    let {id} = useParams();
    let [tap, setTap] = useState(0);   

    let p = {
        color:"#666",
        fontWeight:"400",
    }

    let p2={
        fontSize:"28px",
        padding:0,
        fontWeight:"700",
        color:"#333"
    }

    let numb = useSelector((state)=>state.numb)
    let selproduct  = props.main.find((x) => x.id == id )
    let dispatch = useDispatch()

    return (
        <div>
            <div className='container' style={{background:"#eee", height:"30px"}}>
                <Category main={props.main}></Category>
            </div>

            <div className='container' style={{marginTop:"50px"}}>
                <div className='row'>

                    <div className='col-md-6'>
                        <img src={'/'+selproduct.imgUrl} width="100%"/>
                    </div>

                    <div className='col-md-6'>
                        <p style={p}>Fresh-Webibazaar</p>
                        <h3>{selproduct.title}</h3>
                        <p>{selproduct.contents}</p>
                        <p style={p2}>{selproduct.price}</p>
                        <Bar></Bar>
                        <Quan></Quan>
                        <div className="d-grid gap-2">
                            <Button variant="success" size="lg" onClick={()=>{
                                dispatch(addItem({
                                    id : selproduct.id, 
                                    name : selproduct.title,
                                    count : numb.num,
                                }))
                            }}>Add To Cart</Button>
                            <Button variant="outline-secondary" size="lg" onClick={()=>{
                                dispatch(addItem({
                                    id : selproduct.id, 
                                    name : selproduct.title,
                                    count : numb.num,
                                }))
                            }}>Buy It Now</Button>
                        </div>
                        <Acco></Acco>
                    </div>
                </div>
            </div>
            <div className='container' style={{border:"1px solid #ddd",padding:"18px 0px",marginTop:"20px"}}>
                <div className='container' style={{width:"90%"}}>
                    <h3>You May Also Like</h3>
                    <Other></Other>
                </div>
            </div>
            <div className='container' style={{marginTop:"30px", marginBottom:"30px", padding:0}}>
                <Nav fill variant='tabs' defaultActiveKey="link0" id="detailbav">
                    <Nav.Link onClick={()=>{ setTap(0) }} className="detailTab" eventKey="link0">Description</Nav.Link>
                    <Nav.Link onClick={()=>{ setTap(1) }} className="detailTab" eventKey="link1">Reviews</Nav.Link>
                    <Nav.Link onClick={()=>{ setTap(2) }} className="detailTab" eventKey="link2">Delivery</Nav.Link>
                </Nav>
                <TabContent tap={tap}/>
                </div>
        </div>
    );
};

function Bar () {
    let bar={
        height:"3px",
        backgroundColor:"#ddd",
        position:"relative",
        margintop:"10px",
        padding:0,
        borderRadius:"4px"
    }

    let span ={
        width:"41%",
        backgroundColor:"#4b8106",
        position: "absolute",
        left: 0,
        top: 0,
        height: "100%"
    }

    let p1 ={
        margin:"5px 0px",
        padding:0,
        fontSize:"18px",
        fontWeight:"400",
        color:"#4b8106"
    }

    let p2={
        listStyle:"dics",
        color:"#4b8106"
    }
    return (
        <div style={{marginBottom:"10px"}}>
            <p style={p1}>Shipping</p>
            <p style={p2}>In stock (42 units), ready to be shipped</p>
            <div className='wbstockinfo-bar' style={bar}>
                <span style={span}></span>
            </div>
        </div>
    );
};

function Category (props) {
    let {id} = useParams();
    let ulcss={
        listStyle:"none",
        overflow:"hidden"
    }
    let licss={
        float:"left",
        padding:"2px 4px",
        color:"#666",
        fontWeight:"400",
        cursor:"pointer"
    }

    return (
        <ul style={ulcss}>
            <li style={licss}>Home</li>
            <li style={licss}>|</li>
            <li style={licss}>{props.main[id].title}</li>
        </ul>
    );
};

function Quan () {

    let numb = useSelector((state) => state.numb) ;
    let dispatch = useDispatch();

    let p = {
        padding:0,
        margin:0,
        fontWeight:400
    }

    let css={
        listStyle:"none",
        overflow:"hidden",
        display:"inline-block",
        margin:"5px",
        padding:0,
        border:"1px solid #ddd"
    }

    let css2={
        float:"left",
        padding:"8px",
        cursor:"pointer",
        color:"black"
    }
    return (
        <div>
            <p style={p}>Quantity</p>
            <ul style={css}>
                <li style={css2} onClick={()=>{
                    dispatch(decrease(1))
                }}>-</li>
                <li style={css2}>{numb.num}</li>
                <li style={css2} onClick={()=>{
                    dispatch(increase(1))
                }}>+</li>
            </ul>
        </div>
    );
};

function Acco () {
    return (
        <div style={{marginTop:"30px"}}>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Privacy Policy</Accordion.Header>
                    <Accordion.Body>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                        minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Delivery Information</Accordion.Header>
                    <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                    minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                    pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>About Us</Accordion.Header>
                    <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                    minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                    pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};

function TabContent(props){
    if (props.tap === 0){
        return <Content></Content>
    }else if (props.tap === 1){
        return  <Content2></Content2>
    }else if (props.tap === 2){
        return <Content3></Content3>
    }
}

function Content () {

    return (
        <div>
            <div className='container' style={{width:"90%", marginTop:"20px"}}>
                <div className='row'>
                    <div className='col-md-12' id="detailbanner">
                        <div className='banner'>
                            <p>Up To 50% Off</p>
                            <h1>Natural Farm Fruits</h1>
                        </div>
                    </div>
                </div>
            </div>
            <Table></Table>
            <Img></Img>
            <Img2></Img2>
            <Notice></Notice>
        </div>
    );
};

function Table () {
    let a = {
        width:"80%",
        borderTop:"1px solid #ddd",
        borderBottom:"1px solid #ddd"
   }
    let b={
        width:"21%",
        background:"#eee",
        padding:"10px"
    }
    let c = {
        padding:"0 0 0 10px",
    }
    
    return (
        <>
        <div className='container' style={{width:"90%", margin:"40px auto"}}>
            <h5>Required notation information</h5>
            <table style={a}>
                <tr>
                    <td style={b}>product status</td>
                    <td style={c}>new product</td>
                </tr>
                <tr>
                    <td style={b}>Shipping method</td>
                    <td style={c}>parcel</td>
                </tr>
                <tr>
                    <td style={b}>issue a receipt</td>
                    <td style={c}>Online cash receipt issuance</td>
                </tr>
                <tr>
                    <td style={b}>Date of manufacture</td>
                    <td style={c}>Contact the seller</td>
                </tr>
                <tr>
                    <td style={b}>product number</td>
                    <td style={c}>4700298998</td>
                </tr>
                <tr>
                    <td style={b}>Delivery area</td>
                    <td style={c}>Nationwide</td>
                </tr>
            </table>
        </div>
        </>
    );
};

function Img () {
    let pcss={
        color:"#777",
        fontSize:"18px",
        margin:"0 0 25px 0px",
}
    return (
    <div className='container' style={{width:"90%", marginTop:"40px"}}>
        <h5>We only give you freshness</h5>
        <p style={pcss}>Experience the surprise with early morning delivery. 
            Most importantly, we protect the freshness. 
            If you order before 4pm, it will be delivered to your door 
            the next morning! Order today and how about a glass of fresh fruit 
            juice tomorrow morning? It will revitalize your daily life.</p>
        <img src='/img/detail1.jpg' width="100%" />
        <h5 style={{marginTop:"40px"}}>Take care of your health easily every morning!</h5>
        <p style={pcss}>Take care of your precious family health with freshgo! 
            If it is difficult to order every day, 
            we recommend using the subscription service. 
            The longer the subscription period, 
            the more benefits you will receive. In addition to discounts, 
            we also offer kits that allow you to easily cut and cook fruits 
            and vegetables.
        </p>
        <img src='/img/detail2.jpg' width="100%" />
    </div>
    );
};

function Img2 () {
    let pcss={
        color:"#777",
        fontSize:"18px",
        margin:"0 0 25px 0px",
    }
    return (
        <>
        <div className='container' style={{width:"90%", marginTop:"40px"}}>
            <h5>Freshness unfolds before your eyes!</h5>
            <p style={pcss}>By boldly omitting the middle distribution process, 
            you can purchase faster, fresher and cheaper. 
            Choose if you want to enjoy healthy fruits and 
            vegetables where freshness is life.</p>
        </div>
        <div className='container' style={{width:"90%", marginTop:"40px"}}>
            <div className='row' >
                <div className='col-md-6'>
                    <img src='/img/detail4.jpg' width="100%" />
                </div>
                <div className='col-md-6'>
                    <img src='/img/detail3.jpg' width="100%"></img>
                </div>
            </div>
        </div>
        </>
    );
};

function Notice () {
    let pcss={
        fontSize:"14px",
        color:"#777"
    }
    return (
        <div className='container' style={{width:"90%", marginTop:"50px"}}>
        <h5>Precautions for purchase</h5>
        <ul>
            <li style={pcss}>When purchasing products subject to certification, 
                such as industrial products and electrical appliances, 
                please check whether the products have been approved in 
                accordance with relevant laws such as the 
                'Electrical Appliances and Household Appliances 
                Safety Management Act'.</li>
            <li style={pcss}>The return rules under the 
                「Act on Consumer Protection in Electronic Commerce, 
                Etc.」 take precedence over the return conditions 
                specified by the seller.</li>
            <li style={pcss}>When a minor purchases an item, 
                the minor or his/her legal representative may cancel 
                the purchase if the legal representative does 
                not consent.</li>
        </ul>
    </div>
    );
};

function Content2 () {
    let [review] = useState(data);

    let head ={
        borderBottom:"1px solid black",
    }

    let tr = {
        padding:"5px",
        width:"11%",
        textAlign:"center"
    }

    let tr2= {
        width:"67%",
        textAlign:"center"
    }

    let tr3= {
        width:"9%",
        textAlign:"center"
    }

    return (
        <>
        <div className='container' style={{width:"90%", marginTop:"40px"}}>
            <table style={{width:"100%"}}>
                <thead style={head}>
                    <tr>
                        <th style={tr}>Number</th>
                        <th style={tr2}>Title</th>
                        <th style={tr3}>ID</th>
                        <th style={tr3}>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        review.map((a,i)=>{
                            return(
                                <tr key={i}>
                                <td style={{padding:"9px 0px", textAlign:"center"}}>{review[i].number}</td>
                                <td style={{padding:"9px 0px",cursor:"pointer"}}>{review[i].title}</td>
                                <td style={{padding:"9px 0px", textAlign:"center"}}>{review[i].name}</td>
                                <td style={{padding:"9px 0px", textAlign:"center"}}>{review[i].date}</td>
                            </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            <ListButton></ListButton>
        </div>

        <div className='container' style={{background:"#eee",width:"90%", padding:"13px"}}>
            <Contents></Contents>
        </div>

        <div className='container' style={{width:"90%"}}>
            <BestReview></BestReview>
            <ListButton></ListButton>
        </div>
        </>
    );
};

function ListButton () {
    let ulcss={
        margin:"15px auto",
        overflow:"hidden",
        width:"160px"
    }
    let css={
        listStyle:"none",
        float:"left",
        padding:"3px",
        cursor:"pointer"
    }
    return (
        <ul style={ulcss}>
            <li style={css}>Prev</li>
            <li style={css}>1</li>
            <li style={css}>2</li>
            <li style={css}>3</li>
            <li style={css}>Next</li>
        </ul>
    );
};

function Contents () {
    let box={
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center"
    }
    let input={
        marginRight:"5px"
    }
    return (
        <div style={box}>
            <span>Best Rivew</span>
            <div>
                <input type="text" value="search for review.." style={input}></input>
                <select value="All reviews">
                    <option value="All reviews">All reviews</option>
                    <option value="New">New</option>
                    <option value="Old">Old</option>
                </select>
            </div>
        </div>
    );
};

function BestReview () {
    let ul={
        marginTop:"20px",
        padding:"13px 0px",
        borderBottom:"1px solid #ddd"
    }
    let li={
        listStyle:"none",
        padding:"2px 0px",
        color:"#666"
    }
    let btn={
        border:"none",
        padding:"3px 15px",
        background:"#4b8106",
        color:"#fff",
        marginRight:"5px",
        fontSize:"11px"
    }
    return (
        <div>
            <ul style={ul}>
                <li style={li}>David ***</li>
                <li style={li}>2022.06.01</li>
                <li style={li}>Banana, 3kg</li>
                <li style={li}><img src='/img/review1.jpg' width="16%"/></li>
                <li style={li}>
                It's fresh and the price is good. 
                After eating it often for a while, 
                I am only now writing a review. 
                When I first came, it was blue, 
                so I didn't have to worry about ordering a 
                lot, but these days the weather is so hot 
                that it turns yellow in two days and 
                the taste changes. If you live alone, 
                it would be better to avoid bulk orders, 
                but it is better to share it with friends 
                because it comes packaged in small portions.
                It's fresh because I eat it often, 
                but sometimes the tip of the banana is 
                hardened too black or there is dirt on it.
                However, most of them have a moderately 
                sweet taste and are satisfactory.
                </li>
                <li style={li}>
                    <button style={btn}>Like it</button>
                    <button style={btn}>not good</button>
                </li>
            </ul>
            <ul style={ul}>
                <li style={li}>Suzy G***</li>
                <li style={li}>2022.03.15</li>
                <li style={li}>Kale(Juice), 2pack</li>
                <li style={li}><img src='/img/review2.jpg' width="16%"/></li>
                <li style={li}>
                I trusted it and ordered it because it seems
                to be the freshest place. My family likes 
                it so much. If you eat it as a 
                vegetable, you can't eat it for a while 
                because of the bitter taste and throw it 
                away, but it's good to buy it as a juice 
                package so you can eat it easily and 
                deliciously every morning. I bought two 
                boxes first, but when I finish eating 
                these, I will order as a subscription s
                ervice.
                </li>
                <li style={li}>
                    <button style={btn}>Like it</button>
                    <button style={btn}>not good</button>
                </li>
            </ul>
            <ul style={{marginTop:"20px", padding:"13px 0px"}}>
                <li style={li}>Adrian ***</li>
                <li style={li}>2022.07.18</li>
                <li style={li}>Laim, 3kg</li>
                <li style={li}><img src='/img/review3.jpg' width="16%"/><img src='/img/review4.jpg' width="17%"/></li>
                <li style={li}>
                I bought a lime mojito because I wanted to make it at home. 
                It's good for a variety of uses. It is also used as a 
                culinary decoration and for making natural detergents. 
                If you make a mojito and serve it to your guests, 
                they will love it. I plan to purchase again soon. 
                Because it is shipped directly from the farm, 
                you can trust the freshness of course. 
                It is fresh and good with no soft kernels. 
                This site is recommended to friends as well.
                </li>
                <li style={li}>
                    <button style={btn}>Like it</button>
                    <button style={btn}>not good</button>
                </li>
            </ul>
            
        </div>
    );
};

function Other () {
 let style={
    cursor:"pointer",
    textAlign:"center"
 }
    return (
        <div className='row'>
            <div className='col-md-3' style={style}>
                <img src='/img/also1.jpg' width="78%"></img>
                <p style={{margin:"3px"}}>topping set</p>
                <h5>$180.00</h5>
                <p>★★★★★</p>
            </div>
            <div className='col-md-3' style={style}>
                <img src='/img/also2.jpg' width="78%"></img>
                <p style={{margin:"3px"}}>Summer Fruits</p>
                <h5>$99.00</h5>
                <p>★★★★☆</p>
            </div>
            <div className='col-md-3' style={style}>
                <img src='/img/also3.jpg' width="78%"></img>
                <p style={{margin:"3px"}}>Tropical Fruit Package</p>
                <h5>$120.75</h5>
                <p>★★★★★</p>
            </div>
            <div className='col-md-3' style={style}>
                <img src='/img/main6.jpg' width="78%"></img>
                <p style={{margin:"3px"}}>Onion</p>
                <h5>$55.00</h5>
                <p>★★★★★</p>
            </div>
        </div>
    );
};


function Content3 () {
    let a = {
        width:"80%",
        borderTop:"1px solid #ddd",
        borderBottom:"1px solid #ddd"
   }
    let b={
        width:"21%",
        background:"#eee",
        padding:"10px",
        borderBottom:"1px solid #ddd"
    }
    let c = {
        padding:"0 0 0 10px",
        borderBottom:"1px solid #ddd"
    }

    let pcss={
        fontSize:"14px",
        color:"#777"
    }
    return (
        <div>
            <div className='container' style={{width:"90%", marginTop:"40px"}}>
                <h5>Shipping Information</h5>
                <table style={a}>
                    <thead>
                        <tr>
                            <td style={b}>Shipping method</td>
                            <td style={c}>fresh/refrigerated</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={b}>shipping company</td>
                            <td style={c}>freshgo</td>
                        </tr>
                        <tr>
                            <td style={b}>delivery fee</td>
                            <td style={c}>
                                <ul>
                                    <li>$3.5</li>
                                    <li>Free shipping on purchases over KRW 50,000</li>
                                    <li>Additional shipping cost between islands and mountains</li>
                                    <li>Islands and mountains: 10,000 won</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 style={{marginTop:"25px"}}>Exchange/Return Information</h5>
                <ul>
                    <li style={pcss}>Regarding general exchange/return matters, the relevant laws take precedence over the seller's suggestions.</li>
                    <li style={pcss}>However, if the seller's suggestion is more favorable to the consumer than the relevant laws, the seller's suggestion will be applied.</li>
                </ul>

                <h5 style={{marginTop:"25px"}}>Exchange/Return Restrictions</h5>
                <ul>
                    <li style={pcss}>In the case of order/manufactured products, if the product has already been manufactured</li>
                    <li style={pcss}>In case the value of the product is damaged due to the product packaging being opened and used or installed</li>
                    <li style={pcss}>If the value of the product has significantly decreased due to customer use, time lapse, or partial consumption</li>
                    <li style={pcss}>In case of use of part of the set product, loss of components, or damage/breakdown/contamination due to negligence in handling</li>
                    <li style={pcss}>If the customer requests an exchange/return for free due to a simple change of mind because the color or image is different from the actual due to the difference in monitor resolution</li>
                    <li style={pcss}>In case of request for free exchange/return due to manufacturer's circumstances (launch of new model, etc.) and change in parts price</li>
                </ul>
            </div>
        </div>
    );
};


export default Detail;